/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import MaintenanceService from "../../service/MaintenanceService";
import { Dropdown } from "primereact/dropdown";
import autoTable from "jspdf-autotable";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import LetPriceCode from "../../models/LetPriceCode";
import { InputNumber } from "primereact/inputnumber";
import Company from "../../models/Company";

interface DropdownItem {
    name: string;
    code: string;
}

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    letPriceCdCd: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    letPriceCdDesc: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    letPriceCdType: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    letPriceCdBegRange: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    letPriceCdEndRange: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    letPriceCdAddlCost1: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    letPriceCdAddlCost2: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    letPriceCdAddlCost3: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    letPriceCdCompanyId: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    letPriceCdTimstp: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    letPriceCdUpdUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    letPriceCdUpdTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};

export default function LetPriceCodeView() {
    let empty: LetPriceCode = {
        letPriceCdCd: '',
        letPriceCdDesc: '',
        letPriceCdType: '',
        letPriceCdBegRange: 0,
        letPriceCdEndRange: 0,
        letPriceCdAddlCost1: 0,
        letPriceCdAddlCost2: 0,
        letPriceCdAddlCost3: 0,
        letPriceCdCompanyId: 0,
        letPriceCdTimstp: '',
        letPriceCdUpdUser: '',
        letPriceCdUpdTs: ''
    };

    const types: DropdownItem[] = useMemo(
        () => [
            { name: 'L', code: 'L' },
            { name: 'S', code: 'S' }
        ],
        []
    );

    const [listValues, setListValues] = useState<LetPriceCode[]>([]);
    const [companies, setCompanies] = useState<Company[]>([]);
    const [singleValue, setSingleValue] = useState<LetPriceCode>(empty);
    const [listFilteredData, setListFilteredData] = useState<LetPriceCode[]>([]);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const isNew = useRef(false);
    const form = useForm();
    const formEdit = useForm({ mode: "onChange" });
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { accounts } = useMsal();
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const dt = useRef<any>(null);

    useEffect(() => {
        initFilters();
        MaintenanceService.getLetPriceCds().then(data => {
            setListValues(data);
            setLoading(false);
        });

        MaintenanceService.getCompanies().then(data => {
            setCompanies(data);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        MaintenanceService.getLetPriceCds().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: LetPriceCode) => [
            item.letPriceCdCd,
            item.letPriceCdDesc,
            item.letPriceCdType,
            item.letPriceCdBegRange,
            item.letPriceCdEndRange,
            item.letPriceCdAddlCost1,
            item.letPriceCdAddlCost2,
            item.letPriceCdAddlCost3,
            item.letPriceCdCompanyId,
            item.letPriceCdUpdUser,
            item.letPriceCdUpdTs
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, {
                    head: [['Letter Price Code', 'Description', 'Type', 'Beg Qty Range', 'End Qty Range', 'Addl Charge 1', 'Addl Charge 2', 'Addl Charge 3', 'Company', 'Update User', 'Update Date']],
                    body: bodyData
                });
                doc.save('letPriceCds.pdf');
            });
        });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const letPriceCdCdTemplate = (rowData: LetPriceCode) => {
        return rowData.letPriceCdCd;
    };

    const letPriceCdDescTemplate = (rowData: LetPriceCode) => {
        return rowData.letPriceCdDesc;
    };

    const letPriceCdTypeTemplate = (rowData: LetPriceCode) => {
        return rowData.letPriceCdType;
    };

    const letPriceCdBegRangeTemplate = (rowData: LetPriceCode) => {
        return rowData.letPriceCdBegRange;
    };

    const letPriceCdEndRangeTemplate = (rowData: LetPriceCode) => {
        return rowData.letPriceCdEndRange;
    };

    const letPriceCdAddlCost1Template = (rowData: LetPriceCode) => {
        return rowData.letPriceCdAddlCost1;
    };

    const letPriceCdAddlCost2Template = (rowData: LetPriceCode) => {
        return rowData.letPriceCdAddlCost2;
    };

    const letPriceCdAddlCost3Template = (rowData: LetPriceCode) => {
        return rowData.letPriceCdAddlCost3;
    };

    const letPriceCdCompanyIdTemplate = (rowData: LetPriceCode) => {
        return rowData.letPriceCdCompanyId;
    };

    const letPriceCdUpdUserTemplate = (rowData: LetPriceCode) => {
        return rowData.letPriceCdUpdUser;
    };

    const letPriceCdUpdTsTemplate = (rowData: LetPriceCode) => {
        return rowData.letPriceCdUpdTs;
    };

    const clearNew = () => {
        form.reset();
    }

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNew.current = true;
        let _value = { ...singleValue };

        _value.letPriceCdCd = data.letPriceCdCd;
        _value.letPriceCdDesc = data.letPriceCdDesc;
        _value.letPriceCdType = data.letPriceCdType;
        _value.letPriceCdBegRange = data.letPriceCdBegRange;
        _value.letPriceCdEndRange = data.letPriceCdEndRange;
        _value.letPriceCdAddlCost1 = data.letPriceCdAddlCost1;
        _value.letPriceCdAddlCost2 = data.letPriceCdAddlCost2;
        _value.letPriceCdAddlCost3 = data.letPriceCdAddlCost3;
        _value.letPriceCdCompanyId = data.letPriceCdCompanyId;

        if (accounts[0]) {
            _value.letPriceCdUpdTs = new Date().toISOString();
            _value.letPriceCdUpdUser = accounts[0].username.split('@')[0];
        }

        save(_value);
        form.reset();
    };

    const save = (value: LetPriceCode) => {
        MaintenanceService.addLetPriceCd(value).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Letter Price Code Created', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Letter Price Code', life: 3000 });
        });
    }

    const update = (value: LetPriceCode, oldId: string) => {
        MaintenanceService.updateLetPriceCd(value, oldId).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Letter Price Code Updated', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Letter Price Code', life: 3000 });
        });
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<LetPriceCode[]>) => {
        let selectedIndex = listValues.findIndex(v => v.letPriceCdCd === (rowData.value as LetPriceCode).letPriceCdCd);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].letPriceCdCd}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const onRowEditComplete = (e: any) => {
        let _listValues = [...listValues];
        let { newData } = e;
        let index = listValues.findIndex(v => v.letPriceCdCd === newData.letPriceCdCd);
        _listValues[index] = newData;

        setListValues(_listValues);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'letPriceCdCd':
                return letPriceCdCdEditor(options);

            case 'letPriceCdDesc':
                return letPriceCdDescEditor(options);

            case 'letPriceCdType':
                return letPriceCdTypeEditor(options);

            case 'letPriceCdBegRange':
                return letPriceCdBegRangeEditor(options);

            case 'letPriceCdEndRange':
                return letPriceCdEndRangeEditor(options);

            case 'letPriceCdAddlCost1':
                return letPriceCdAddlCost1Editor(options);

            case 'letPriceCdAddlCost2':
                return letPriceCdAddlCost2Editor(options);

            case 'letPriceCdAddlCost3':
                return letPriceCdAddlCost3Editor(options);

            case 'letPriceCdCompanyId':
                return letPriceCdCompanyIdEditor(options);

            default:
                return null;
        }
    }

    const letPriceCdCdEditor = (options: any) => {
        return (
            <Controller
                name="letPriceCdCdEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Code is required.',
                    maxLength: {
                        value: 3,
                        message: 'Code must be at most 3 characters.',
                    },
                    validate: {
                        unique: v => listValues.filter(val => val.letPriceCdCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Code must be unique.'
                    }
                }}
                render={({ field, fieldState }) => {
                    singleValue.letPriceCdCd = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={3} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.letPriceCdCd = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Code" />
                        </>
                    )
                }}
            />
        );
    }

    const letPriceCdDescEditor = (options: any) => {
        return (
            <Controller
                name="letPriceCdDescEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Description is required.',
                    maxLength: {
                        value: 25,
                        message: 'Description must be at most 25 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.letPriceCdDesc = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={25} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.letPriceCdDesc = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }}
            />
        );
    }

    const letPriceCdTypeEditor = (options: any) => {
        return (
            <Controller
                name="letPriceCdTypeEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Type is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.letPriceCdType = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={types} optionLabel="name" optionValue="code" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.letPriceCdType = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }}
            />
        );
    }

    const letPriceCdBegRangeEditor = (options: any) => {
        return (
            <Controller
                name="letPriceCdBegRangeEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Begin Range is required.',
                    max: {
                        value: 999,
                        message: 'Begin Range must be at most 999.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.letPriceCdBegRange = field.value;
                    return (
                        <>
                            <InputNumber ref={field.ref} value={fieldState.isDirty ? field.value : options.value} max={999} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onValueChange={(e) => { singleValue.letPriceCdBegRange = e.value ?? 0; field.onChange(e.value); }} placeholder="Begin Range" />
                        </>
                    )
                }}
            />
        );
    }

    const letPriceCdEndRangeEditor = (options: any) => {
        return (
            <Controller
                name="letPriceCdEndRangeEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'End Range is required.',
                    max: {
                        value: 999,
                        message: 'End Range must be at most 999.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.letPriceCdEndRange = field.value;
                    return (
                        <>
                            <InputNumber ref={field.ref} value={fieldState.isDirty ? field.value : options.value} max={999} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onValueChange={(e) => { singleValue.letPriceCdEndRange = e.value ?? 0; field.onChange(e.value); }} placeholder="End Range" />
                        </>
                    )
                }}
            />
        );
    }

    const letPriceCdAddlCost1Editor = (options: any) => {
        return (
            <Controller
                name="letPriceCdAddlCost1Edit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Additional Cost 1 is required.',
                    validate: validateDecimal
                }}
                render={({ field, fieldState }) => {
                    singleValue.letPriceCdAddlCost1 = field.value;
                    return (
                        <>
                            <InputNumber ref={field.ref} value={fieldState.isDirty ? field.value : options.value} mode="decimal" useGrouping={false} minFractionDigits={2} maxFractionDigits={2} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onValueChange={(e) => { singleValue.letPriceCdAddlCost1 = e.value ?? 0; field.onChange(e.value); }} placeholder="Additional Cost 1" />
                        </>
                    )
                }}
            />
        );
    }

    const letPriceCdAddlCost2Editor = (options: any) => {
        return (
            <Controller
                name="letPriceCdAddlCost2Edit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Additional Cost 2 is required.',
                    validate: validateDecimal
                }}
                render={({ field, fieldState }) => {
                    singleValue.letPriceCdAddlCost2 = field.value;
                    return (
                        <>
                            <InputNumber ref={field.ref} value={fieldState.isDirty ? field.value : options.value} mode="decimal" useGrouping={false} minFractionDigits={2} maxFractionDigits={2} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onValueChange={(e) => { singleValue.letPriceCdAddlCost2 = e.value ?? 0; field.onChange(e.value); }} placeholder="Additional Cost 2" />
                        </>
                    )
                }}
            />
        );
    }

    const letPriceCdAddlCost3Editor = (options: any) => {
        return (
            <Controller
                name="letPriceCdAddlCost3Edit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Additional Cost 3 is required.',
                    validate: validateDecimal
                }}
                render={({ field, fieldState }) => {
                    singleValue.letPriceCdAddlCost3 = field.value;
                    return (
                        <>
                            <InputNumber ref={field.ref} value={fieldState.isDirty ? field.value : options.value} mode="decimal" useGrouping={false} minFractionDigits={2} maxFractionDigits={2} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onValueChange={(e) => { singleValue.letPriceCdAddlCost3 = e.value ?? 0; field.onChange(e.value); }} placeholder="Additional Cost 3" />
                        </>
                    )
                }}
            />
        );
    }

    const letPriceCdCompanyIdEditor = (options: any) => {
        return (
            <Controller
                name="letPriceCdCompanyIdEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Company is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.letPriceCdCompanyId = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={companies} optionLabel="companyName" optionValue="companyId" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.letPriceCdCompanyId = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }}
            />
        );
    }

    const rowEditorTemplate = (rowData: LetPriceCode, props: any) => {
        const rowEditor = props.rowEditor;

        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEdit.getFieldState("letPriceCdDesc").invalid && !formEdit.getFieldState("letPriceCdType").invalid) {
                            let _singleValue = { ...singleValue };
                            let oldId = rowData.letPriceCdCd;

                            if (accounts[0]) {
                                _singleValue.letPriceCdUpdTs = new Date().toISOString();
                                _singleValue.letPriceCdUpdUser = accounts[0].username.split('@')[0];
                            }

                            update(_singleValue, oldId);
                            formEdit.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEdit.clearErrors();
                        formEdit.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
            );
        }
    }

    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: LetPriceCode) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteLetPriceCd(singleValue.letPriceCdCd).then(() => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });

    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    const validateDecimal = (value: number | null) => {
        if (value === null) return 'Value is required.';
        const regex = /^\d{1,3}(\.\d{0,2})?$/;
        return regex.test(value.toString()) || 'Enter a number with up to 3 digits before and 2 after the decimal.';
    };

    return (
        <>
            <Toast ref={toast} />

            <Panel header="Add Letter Price" className="addPanel mb-2 -ml-2">
                <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-2">
                            <Controller
                                name="letPriceCdCd"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Letter Price Code is required.',
                                    maxLength: {
                                        value: 3,
                                        message: 'Letter Price Code must be at most 3 characters.',
                                    },
                                    validate: {
                                        unique: v => listValues.filter(val => val.letPriceCdCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Letter Price Code must be unique.'
                                    }
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Letter Price Code</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={3} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Letter Price Code" />
                                        {getErrorMessage('letPriceCdCd')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="letPriceCdDesc"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.',
                                    maxLength: {
                                        value: 25,
                                        message: 'Description must be at most 25 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={25} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Description" />
                                        {getErrorMessage('letPriceCdDesc')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="letPriceCdType"
                                control={form.control}
                                rules={{
                                    required: 'Type is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Type</label>
                                        <Dropdown inputId={field.name} value={field.value} options={types} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('letPriceCdType')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="letPriceCdBegRange"
                                control={form.control}
                                defaultValue={0}
                                rules={{
                                    required: 'Begin Range is required.',
                                    max: {
                                        value: 999,
                                        message: 'Begin Range must be at most 999.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Beg Qty Range</label>
                                        <InputNumber id={field.name} name={field.name} value={field.value} max={999} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onValueChange={(e) => field.onChange(e.value)} placeholder="Beg Qty Range" />
                                        {getErrorMessage('letPriceCdBegRange')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="letPriceCdEndRange"
                                control={form.control}
                                defaultValue={0}
                                rules={{
                                    required: 'End Range is required.',
                                    max: {
                                        value: 999,
                                        message: 'End Range must be at most 999.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">End Qty Range</label>
                                        <InputNumber id={field.name} name={field.name} value={field.value} max={999} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onValueChange={(e) => field.onChange(e.value)} placeholder="End Qty Range" />
                                        {getErrorMessage('letPriceCdEndRange')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="letPriceCdAddlCost1"
                                control={form.control}
                                defaultValue={0}
                                rules={{
                                    required: 'Addl Charge 1 is required.',
                                    validate: validateDecimal,
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Addl Charge 1</label>
                                        <InputNumber
                                            id={field.name}
                                            name={field.name}
                                            value={field.value}
                                            mode="decimal"
                                            useGrouping={false}
                                            minFractionDigits={2}
                                            maxFractionDigits={2}
                                            className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                            onValueChange={(e) => field.onChange(e.value)}
                                            placeholder="Addl Charge 1"
                                        />
                                        {getErrorMessage('letPriceCdAddlCost1')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="letPriceCdAddlCost2"
                                control={form.control}
                                defaultValue={0}
                                rules={{
                                    required: 'Addl Charge 2 is required.',
                                    validate: validateDecimal,
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Addl Charge 2</label>
                                        <InputNumber
                                            id={field.name}
                                            name={field.name}
                                            value={field.value}
                                            mode="decimal"
                                            useGrouping={false}
                                            minFractionDigits={2}
                                            maxFractionDigits={2}
                                            className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                            onValueChange={(e) => field.onChange(e.value)}
                                            placeholder="Addl Charge 2"
                                        />
                                        {getErrorMessage('letPriceCdAddlCost2')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="letPriceCdAddlCost3"
                                control={form.control}
                                defaultValue={0}
                                rules={{
                                    required: 'Addl Charge 3 is required.',
                                    validate: validateDecimal,
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Addl Charge 3</label>
                                        <InputNumber
                                            id={field.name}
                                            name={field.name}
                                            value={field.value}
                                            mode="decimal"
                                            useGrouping={false}
                                            minFractionDigits={2}
                                            maxFractionDigits={2}
                                            className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                            onValueChange={(e) => field.onChange(e.value)}
                                            placeholder="Addl Charge 3"
                                        />
                                        {getErrorMessage('letPriceCdAddlCost3')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="letPriceCdCompanyId"
                                control={form.control}
                                rules={{
                                    required: 'Company is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Company</label>
                                        <Dropdown inputId={field.name} value={field.value} options={companies} optionLabel="companyName" optionValue="companyId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('letPriceCdCompanyId')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>

            </Panel>

            <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="letPriceCdCd" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange} onRowEditComplete={onRowEditComplete}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} header={header} onValueChange={filteredData => setListFilteredData(filteredData)}
                emptyMessage="No letter price code records found.">

                <Column field="letPriceCdCd" header="Letter Price Code" sortable body={letPriceCdCdTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="letPriceCdDesc" header="Description" sortable body={letPriceCdDescTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                <Column field="letPriceCdType" header="Type" sortable body={letPriceCdTypeTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="letPriceCdBegRange" header="Beg Qty Range" sortable body={letPriceCdBegRangeTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="letPriceCdEndRange" header="End Qty Range" sortable body={letPriceCdEndRangeTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="letPriceCdAddlCost1" header="Addl Charge 1" sortable body={letPriceCdAddlCost1Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="letPriceCdAddlCost2" header="Addl Charge 2" sortable body={letPriceCdAddlCost2Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="letPriceCdAddlCost3" header="Addl Charge 3" sortable body={letPriceCdAddlCost3Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="letPriceCdCompanyId" header="Company" sortable body={letPriceCdCompanyIdTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="letPriceCdUpdUser" header="Update User" sortable body={letPriceCdUpdUserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="letPriceCdUpdTs" header="Update Date" sortable body={letPriceCdUpdTsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValue && (
                        <span>
                            Are you sure you want to delete <b>{singleValue.letPriceCdCd} - {singleValue.letPriceCdDesc}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}